import React from 'react'
import ModeSelect from 'src/components/dashboard/ModeSelect'
export default function ModeSelectView(
  props: React.ComponentProps<typeof ModeSelect>
): JSX.Element {
  return <ModeSelect {...props} />
}
